import { useEnabledProjectColumns } from '~/modules/common/hooks/project';
import { useTableSettings } from '~/modules/common/components/ListTable';
import { PROJECT_LIST_PAGE_TYPE } from '~/modules/common/enums/ProjectListPageType';

const TABLE_KEY = 'portfolio-projects-list';

const usePortfolioProjectListTableSettings = () => {
  const {
    enabledProjectColumnNames,
    enabledProjectColumnGroups
  } = useEnabledProjectColumns({
    hideClient: true,
    includeGroupsInDefaultColumnNames: false,
    projectListPageType: PROJECT_LIST_PAGE_TYPE.PORTFOLIO
  });

  const { data: tableSettingsData, loading } = useTableSettings({
    tableKey: TABLE_KEY,
    defaultColumns: enabledProjectColumnNames
  });
  const selectedColumnNames = tableSettingsData?.columns;

  return {
    tableKey: TABLE_KEY,
    enabledProjectColumnGroups,
    enabledProjectColumnNames,
    selectedColumnNames,
    tableSettingsDataLoading: loading
  };
};

export default usePortfolioProjectListTableSettings;
